






























































import { Component, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import { CollectionListStatus } from '@/types'
import { collectionListStore } from '@/utils/store-accessor'

export interface CollectionListSearchConditionItem {
  name: {
    input: string
  }
  status: {
    input: CollectionListStatus
  }
}

export const defaultCollectionListSearchConditionItem = (): CollectionListSearchConditionItem => ({
  name: {
    input: ''
  },
  status: {
    input: CollectionListStatus.All
  }
})

@Component({
  components: {}
})
export default class CollectionListSearchCondition extends ComponentVue {
  @Ref()
  nameTextField!: AtomTextField

  get searchCondition(): CollectionListSearchConditionItem {
    return collectionListStore.searchCondition
  }

  get name(): string {
    return collectionListStore.searchCondition.name.input
  }

  set name(value: string) {
    collectionListStore.setName(value)
  }

  get status(): CollectionListStatus {
    return collectionListStore.searchCondition.status.input
  }

  set status(value: CollectionListStatus) {
    collectionListStore.setStatus(value)
  }

  get collectionListStatus(): any {
    return CollectionListStatus
  }

  focusName(): void {
    this.nameTextField.atomTextField.focus()
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
